import React from 'react';
import { Modal, Button, FormItem, Input, Select, TextArea, Alert } from 'elmo-elements';
import { Fieldset } from 'src/components/Fieldset';
import type { TCreateEditNoticeProps } from './types';
import { useCreateEditNoticeModalState } from './hooks/useCreateEditNoticeModalState';

export const CreateEditNotice = (props: TCreateEditNoticeProps) => {
    const { isEdit = false } = props;

    const {
        state,
        handleHtmlEvent,
        errors,
        handleSubmit,
        handleCloseModal,
        handleSelect,
        locations,
        isLoading,
        serverErrors,
        setServerErrors,
    } = useCreateEditNoticeModalState(props);

    const action = isEdit ? 'Edit' : 'Add';

    return (
        <Modal
            primaryButton={
                <Button onClick={handleSubmit} isLoading={isLoading} type="primary">
                    {action}
                </Button>
            }
            type="medium"
            closeModal={handleCloseModal}
            title={`${action} Notice`}
            isOpened
        >
            {!!serverErrors.length && (
                <Alert
                    role="alert"
                    type="danger"
                    onClose={() => {
                        setServerErrors([]);
                    }}
                >
                    {serverErrors.join(', ')}
                </Alert>
            )}

            <Fieldset>
                <FormItem
                    className="required"
                    label="Notice Subject"
                    message={errors.title?.[0]}
                    status={errors.title?.length ? 'error' : undefined}
                >
                    <Input
                        name="title"
                        value={state.title}
                        onChange={handleHtmlEvent}
                        ariaLabel="Title"
                    />
                </FormItem>
                <FormItem>
                    <Select
                        options={locations}
                        onChange={({ value }) => {
                            handleSelect(value);
                        }}
                        value={locations.find((location) => location.value === state.location_id)}
                        ariaLabel="Location label"
                    />
                </FormItem>
                <FormItem
                    className="required"
                    label="Message"
                    message={errors.text?.[0]}
                    status={errors.text?.length ? 'error' : undefined}
                >
                    <TextArea value={state.text} onChange={handleHtmlEvent} name="text" />
                </FormItem>
            </Fieldset>
        </Modal>
    );
};
